import { render, staticRenderFns } from "./presidencyBrdListComp.vue?vue&type=template&id=02909724&scoped=true"
import script from "./presidencyBrdListComp.vue?vue&type=script&lang=js"
export * from "./presidencyBrdListComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02909724",
  null
  
)

export default component.exports